/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SsoimageCategories200,
  GetApiV1SsoimageCategories401,
  GetApiV1SsoimageCategories500,
  GetApiV1SsoimageCategoriesQueryResponse,
} from "../../types/SSOImageController/GetApiV1SsoimageCategories.ts";
import { SSOEnumItemViewModelSchema } from "../SSOEnumItemViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SsoimageCategories200Schema = z.array(
  z.lazy(() => SSOEnumItemViewModelSchema),
) as unknown as ToZod<GetApiV1SsoimageCategories200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SsoimageCategories401Schema =
  z.any() as unknown as ToZod<GetApiV1SsoimageCategories401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SsoimageCategories500Schema =
  z.any() as unknown as ToZod<GetApiV1SsoimageCategories500>;

export const getApiV1SsoimageCategoriesQueryResponseSchema = z.lazy(
  () => getApiV1SsoimageCategories200Schema,
) as unknown as ToZod<GetApiV1SsoimageCategoriesQueryResponse>;
